module.exports = __webpack_public_path__ + "9645dd09f0397394f7e300889440753f.fbx";